module.exports = __webpack_public_path__ + "img/search.3d4092ed.svg";